jQuery(function() {
    (function($) {

        omadapp.singletons.implementador = new(function() {
            var t = this;
            t.implementar = implementar
            
            function implementar (target, interfaz) {
                
                target.super = target.super||{}
                for (var n in interfaz) {
                    if (!target[n]) {
                        target[n] = interfaz[n]
                    } else {
                        target.super[n] = interfaz[n]
                    }
                }
            }
        })


    })(jQuery);
});